<template lang="">
  <v-dialog v-model="dialog" persistent max-width="500"  transition="dialog-transition">
    <v-card full-width class="text-center">
      <v-toolbar
          :color="toolbarColor"
          dark
        >	<v-card-title class="text-h5">
        {{ tituloDialogo }}
        </v-card-title>
      </v-toolbar>
      <v-card-text :style="'font-size:120%'" class="mt-6">{{textoDialogo}}</v-card-text>
      <div v-if="tipo == 'arrancar'">
        <v-row justify="center" align="center" style="max-width: 100%" >
           <v-col justify="center" align="center" cols="6">
            <v-radio-group 
            v-model="radios"
            mandatory
            >
            <v-radio
            label="Ahora"
            value="0"
            ></v-radio>
            <v-radio
            label="Programado"
            value="1"
            ></v-radio>
          </v-radio-group>
        </v-col>
        </v-row>

        <!-- inicio de horno programado -->
        <v-row v-if="radios.includes(1)" class="ml-5 mr-5">
          <v-col cols="6">
            <v-menu 
              ref="pickerFecha"
              v-model="pickerFecha"
              :close-on-content-click="false"
              :return-value.sync="fechaInicio"
              transition="scale-transition"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fechaInicio"
                  label="Fecha"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fechaInicio" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="pickerFecha = false">
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.pickerFecha.save(fechaInicio);"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu
              ref="pickerHora"
              v-model="pickerHora"
              :close-on-content-click="false"
              :return-value.sync="horaInicio"
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="horaInicio"
                  label="Hora"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="pickerHora"
                format="24hr"
                v-model="horaInicio"
                @click:minute="$refs.pickerHora.save(horaInicio)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>

        <!-- Introduccir of, cantidad y colada -->
        <div class="ml-5 mr-5">
          <v-card>
            <v-card-title>OF relacionadas
              <v-spacer></v-spacer>
              <v-btn color="blue" dark @click="anadirOF">Añadir Of</v-btn>
            </v-card-title>

            <v-card-text> Editar mediante doble click</v-card-text>

            <!-- Tabla ofs -->
            <v-data-table :items="items" :headers="headers" hide-default-footer
            :items-per-page="items.length"
            
            >

              <template v-slot:item.of="{ item }">
                <input-numero-editable :valor="item.of" @cambio="actualizarOf" :id="item.id"></input-numero-editable>
              </template>
              <template v-slot:item.cantidad="{ item }">
                <input-numero-editable :valor="item.cantidad" @cambio="actualizarCantidad" :id="item.id"></input-numero-editable>
              </template>
              <template v-slot:item.colada="{ item }">
                <input-numero-editable :valor="item.colada" @cambio="actualizarColada" :id="item.id"></input-numero-editable>
              </template>
              <template v-slot:item.actions="{ item }">
                <!-- <v-icon small @click="editItem(item)">
                  mdi-pencil
                </v-icon> -->
                <v-icon small @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </div>

        </div>
					<v-card-actions>
            <v-spacer></v-spacer>
						<v-btn color="black" text @click="cancelar()">
							Cancelar
						</v-btn>
            <v-btn :color="buttonColor" text @click="aceptar()">
              Aceptar
            </v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-dialog>
</template>
<script>
import moment from 'moment-timezone';
import InputNumeroEditable from '@/components/modulos/InputNumeroEditable.vue'
import { mapActions } from "vuex";

export default {
  components: {
    InputNumeroEditable
  },
  props:{
    tituloDialogo:String,
    textoDialogo:String,
    nombreMetodo:String,
    activar:Boolean,
    toolbarColor:String,
    buttonColor:String,
    tipo:String,

  },
  data() {
    return {
      payload:{},
      dialog:false,
      radios:[],
      fechaInicio:"",
      horaInicio:"",
      pickerFecha:false,
      pickerHora:false,
      headers: [
        // { text: "ID trabajo", value: "id_trabajo" },
        // { text: "ID OFS", value: "id" },
        { text: "Nº OF", value: "of" },
        { text: "Cantidad", value: "cantidad" },
        { text: "Colada", value: "colada" },
        { text: "Opciones", value: "actions" },
      ],
      items: [],
      id_trabajo: 805,
    };
  },
  watch:{
    activar(){
      if(this.activar) this.dialog = true
    }
  },
  mounted(){
    const now = new Date();
    this.horaInicio = moment(now).format('HH:mm')
    this.fechaInicio  = moment(now).format('yyyy-MM-DD')
  },
  methods: {
    ...mapActions("api",['getOfs','updateOfs','deleteOfs','createOf','getUltimoTratamiento']),
    aceptar(){
      if(this.nombreMetodo){
        let payload = {}
        if(this.tipo == 'arrancar'){ // mandamos como payload la fecha de arranque, ya sea ahora (se calcula en el mounted) o programada
          if(this.radios.includes(0)){// si se marca el ahora
            const now = new Date();
            this.horaInicio = moment(now).format('HH:mm')
            this.fechaInicio  = moment(now).format('yyyy-MM-DD')
          }
          const combinedDateTimeString = `${this.fechaInicio}T${this.horaInicio}:00`;
          payload =  Date.parse(combinedDateTimeString);
        }
        this.$emit(this.nombreMetodo, payload)
        this.dialog = false
      }
    },
    anadirOF(){
      this.createOf(this.id_trabajo).then( res => {  
        console.log(res)
        let nueva_of = {
          id: res.data[0].id_ofs,
          of: 'SIN RELLENAR',
          cantidad: 0,
          colada: 'SIN RELLENAR'
        }
        this.items.push(nueva_of)
      })
    },
    editItem(item){
      console.log('edit ' + item);
    },
    deleteItem(item){
      console.log('delete ' + item);
      this.items = this.items.filter(e => e.id != item.id)
      this.deleteOfs(item.id)
    },
    actualizarOf(payload){
      let item = this.items.filter(e => e.id == payload.id)
      item[0].of = payload.valor
      this.updateOfs(item[0])
    },
    actualizarCantidad(payload){
      let item = this.items.filter(e => e.id == payload.id)
      item[0].cantidad = payload.valor
      this.updateOfs(item[0])
    },
    actualizarColada(payload){
      let item = this.items.filter(e => e.id == payload.id)
      item[0].colada = payload.valor
      this.updateOfs(item[0])
    },
    cancelar(){
      this.$emit('cancelar')
      this.dialog = false
    },
    async getOFS(){
      //Obtener of-s añadidas al ciclo, si es que las hay
      await this.getIdTrabajo()
      let ofs = await this.getOfs(this.id_trabajo)
      this.items = []
      ofs.data.forEach(element => {
        this.items.push(element)
      });
    },
    async getIdTrabajo(){
      let res = await this.getUltimoTratamiento()
      console.log('Último tratamiento');
      console.log(res.data);
      this.id_trabajo = res.data.id_trabajo
    },
  },
  created() {
    this.getOFS()
  },
}
</script>
<style lang="">
  
</style>